import React from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import { IOrderBumpPagination } from "../types/OrderBump";
import OrderBumpController from "../controllers/OrderBumpController";

export interface IOrderBumpsProp {
    page: number;
    rows: number;
    search?: string;
}

const valueDefault = {
    items: [],
    page: 0,
    rowsPerPage: 0,
    totalPages: 0,
    total: 0,
};

export const useOrderBumps = ({ page, rows, search }: IOrderBumpsProp) => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<IOrderBumpPagination>(valueDefault);
    const [error, setError] = React.useState<string>('');

    const execute = async () => {
        if (!loading) {
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await OrderBumpController.getAll({ page, rows, search });
                const responseError = response as IErrorResponse;
                const responseData = response as IOrderBumpPagination;

                if (responseError.code) {
                    setError(responseError.error);
                    setData(valueDefault);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, [page, rows]);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}